module.exports = __webpack_public_path__ + "static/media/5f8de7ec5ae7590275f0747d_logo_200x200.5591cf7d.png";